import React, { useEffect } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import HRDashboard from "../module/hr/Dashboard/HRDashboard";
import EmploymentPage from "../module/employment/Employmentpage/pages/EmploymentPage";
import EmploymentProfilePage from "../module/employment/Employmentpage/pages/EmploymentProfilePage";

import EmploymentDashboard from "../module/employment/Dashboard/Dashboard";
import Employee from "../module/hr/Employee/Employee";
import EmploymentDetails from "../module/hr/Employee/components/EmployeeModal/components/EmploymentDetails";
import PersonalInformation from "../module/hr/Employee/components/EmployeeModal/components/PersonalInformation";
import SalaryBankDetails from "../module/hr/Employee/components/EmployeeModal/components/SalaryBankDetails";

import Dashboard from '../module/project/Dashboard/Dashboard';
import EmployeeRoutes from "../module/employee/Dashboard/routes/EmployeeRoutes";
import EmployeeDirectoryPage from "../module/employee/Hirarchy/pages/EmployeeDirectoryPage";
import EmployeeFullProfilePage from "../module/employee/Hirarchy/pages/EmployeeFullProfilePage";
import OrgDashboard from "../module/organization-structure/Dashboard/OrgDashboard";
import axiosInstance from "../common/axiosInstance";

import EmergencyContact from '../module/hr/Employee/components/EmployeeModal/components/EmergencyContact';
import DocumentUpload from '../module/hr/Employee/components/EmployeeModal/components/Documents';

// Layout Wrapper: Displays the sidebar and allows the right section to take full access cleanly
const Layout = () => {
  return (
    <div className="flex w-full h-screen bg-slate-50 font-sans overflow-hidden">
      <Sidebar />
      {/* Right section with full access and zero card constraints */}
      <main className="flex-1 flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-auto w-full h-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

// Reusable page component without cards or inner padding blocks
const PageContent = ({ title }) => (
  <div className="w-full h-full p-6">
    <h1 className="text-3xl font-bold text-slate-800 mb-2">{title}</h1>
    <p className="text-slate-500">Full screen content view for {title}.</p>
  </div>
);

export default function RouteApp() {
  useEffect(() => {
    const testApi = async () => {
      try {
        const response = await axiosInstance.get("/");
        console.log("API SUCCESS:", response.data);
      } catch (error) {
        console.error("API ERROR:", error);
      }
    };

    testApi();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Default route renders Dashboard initially */}
        <Route index element={<PageContent title="Dashboard" />} />

        {/* Top-level Tabs */}
        <Route path="organizations" element={<PageContent title="Organizations" />} />
        <Route path="employee/*" element={<EmployeeRoutes />} />
        <Route path="employment" element={<PageContent title="Employment" />} />
        <Route path="hr" element={<PageContent title="HR" />} />
        <Route path="dsr" element={<PageContent title="DSR" />} />

        {/* Subtabs Routes */}

        {/*  org-structure Routes */}
        <Route path="org-structure/departments" element={<PageContent title="Departments" />} />
        <Route path="org-structure/dashboard" element={<OrgDashboard />} />

        {/* employee Routes */}
        <Route path="employees" element={<EmployeeDirectoryPage />} />
        <Route path="employees/profile/:uuid" element={<EmployeeFullProfilePage />} />

        {/* hr Routes */}
        <Route path="hr/dashboard" element={<HRDashboard />} />
        <Route path="hr/employee" element={<Employee />} />
        <Route path="hr/assets" element={<PageContent title="Assets" />} />
        <Route path="hr/leaves" element={<PageContent title="Leaves" />} />
        <Route path="hr/onboarding" element={<PageContent title="Onboarding" />} />
        <Route path="hr/employee/add" element={<PersonalInformation />} />
        <Route path="hr/employee/add/employment" element={<EmploymentDetails />} />
        <Route path="hr/employee/add/salary" element={<SalaryBankDetails />} />
        <Route path="hr/employee/add/emergency" element={<EmergencyContact />} />
        <Route path="hr/employee/add/documents" element={<DocumentUpload />} />
        
        {/* project Routes */}
        <Route path="project/active" element={<PageContent title="Active Projects" />} />
        <Route path="projects" element={<Dashboard />} />
        
        {/* employment Routes */}
        <Route path="employment/dashboard" element={<EmploymentDashboard />} />
        <Route path="employment/employmentpage" element={<EmploymentPage />} />
        <Route path="employment/profile/:uuid" element={<EmploymentProfilePage />} />

        {/* 404 Catch-All */}
        <Route path="*" element={<PageContent title="404 - Page Not Found" />} />
      </Route>
    </Routes>
  );
}